<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17.986" height="9.963" viewBox="0 0 17.986 9.963">
    <path
      d="M-2042.014-3914.037H-2060l17.986-9.963v9.962Zm-1.135-7.94h0l-13.021,6.891h13.021v-6.891Z"
      transform="translate(2060 3924)"
    />
  </svg>
</template>
